import { CircularProgress } from "@mui/joy";
import { SaveButton } from "./SaveButton";
import { CancelButton } from "./CancelButton";

interface Props {
    isLoading: boolean;
    saveButtonText?: string;
    saveButtonType?: "submit" | "reset" | "button" | undefined;
    disabledSaveButton?: boolean;
    onSave?: () => void;
    cancelButtonText?: string; 
    onCancel?: () => void;
}

export function ActionButtons({ 
        isLoading,
        saveButtonType = "submit",
        saveButtonText = "Crear",
        disabledSaveButton,
        cancelButtonText,
        onCancel,
        onSave }: Props) {
    return (
        <div className="flex justify-center gap-x-4">
            {isLoading
            ? 
            <div className="w-[27px] h-[27px] flex items-center justify-center">
                <CircularProgress sx={{
                    "--CircularProgress-progressThickness": "4px",
                    "--CircularProgress-trackThickness": "4px",
                    "--CircularProgress-size": "25px"
                }}/>
            </div>
            : 
            <>
            <SaveButton
                disabled={disabledSaveButton}
                onClick={onSave}
                text={saveButtonText}
                type={saveButtonType}/>

            <CancelButton
                text={cancelButtonText}
                onClick={onCancel}/>
            </>
            }
        </div>
    );
}